import store from '../store/index';
import { getVersion, getErrorCode } from '@/api/api';
import errorData from './errorCode';

(() => {
  (JSON.stringify(store.getters.errorData) == "{}") && newCode(errorData.error_list,errorData.version);
  getVersion()
    .then((res) => {
      if (res && res.error_code == 0) {
        const errorVersion = store.getters.errorVersion;
        if (errorVersion != res.data.version) {
          updateErrorCode();
        }
      }
    })
    .catch((err) => {
      newCode(errorData.error_list,errorData.version);
    });
})();

function newCode(errorList,version) {
  let newMsg = {};
  errorList.forEach((element) => (newMsg[element.code] = element));
  store.commit('setErrorVersion', version);
  store.commit('setErrorData', newMsg);
}

async function updateErrorCode() {
  const errorJson = await getErrorCode();
  if (errorJson.error_code == 0) newCode(errorJson.data.error_list,errorJson.data.version);
}



// WEBPACK FOOTER //
// ./src/utils/transformCode.js